var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    xmlns: "http://www.w3.org/2000/svg",
    height: 91,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    "data-testid": "speaker",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.212 76.357c-3.267 0-6.535-2.151-6.535-6.246V56.916h1.654v13.195c0 3.144 2.524 4.55 4.881 4.55 2.358 0 4.757-1.406 4.757-4.55V54.517h1.655v15.594c.041 4.302-3.309 6.246-6.412 6.246Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.943 72.8c-1.158 0-2.73-.165-3.474-1.406l-.993-1.738c-3.475-6.163-7.404-13.153-22.254-16.462H14.436c-1.779 0-3.268-1.448-3.268-3.227V37.724c0-1.779 1.448-3.227 3.268-3.227h17.828c14.849-3.309 18.779-10.299 22.253-16.462l.993-1.738c.745-1.241 2.316-1.406 3.475-1.406 1.24 0 2.399.414 3.309 1.199.992.869 1.53 2.11 1.53 3.558v48.354c0 1.448-.538 2.688-1.53 3.557-.91.827-2.069 1.241-3.351 1.241Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.174 51.705c15.097 3.515 19.192 10.754 22.791 17.124l.993 1.737c.207.373.91.579 2.027.579.827 0 1.613-.289 2.192-.785.62-.538.951-1.365.951-2.317V19.648c0-.952-.331-1.779-.951-2.317a3.385 3.385 0 0 0-2.192-.786c-1.117 0-1.82.207-2.027.58l-.993 1.737c-3.64 6.37-7.694 13.608-22.791 17.124v15.719ZM14.436 36.152c-.869 0-1.572.703-1.572 1.572v12.243c0 .869.703 1.572 1.572 1.572h17.083V36.152H14.436ZM22.171 72.055c-1.903 0-3.806-1.282-3.806-3.764V56.916h1.655v11.375c0 1.448 1.075 2.11 2.151 2.11 1.075 0 2.151-.662 2.151-2.11V54.517h1.654v13.774c0 2.482-1.902 3.764-3.805 3.764ZM73.793 58.323l-1.158-1.2c3.598-3.557 5.542-8.273 5.542-13.278 0-5.005-1.985-9.761-5.542-13.277l1.158-1.2a20.274 20.274 0 0 1 6.039 14.477c.041 5.46-2.11 10.631-6.039 14.478Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.304 52.49-1.159-1.199c1.986-1.986 3.103-4.633 3.103-7.446 0-2.812-1.117-5.46-3.103-7.445l1.159-1.2c2.316 2.317 3.598 5.378 3.598 8.645.042 3.268-1.241 6.329-3.598 8.645ZM68.953 48.52l-1.158-1.2c.951-.91 1.448-2.151 1.448-3.475 0-1.323-.497-2.564-1.448-3.474l1.158-1.2a6.571 6.571 0 0 1 1.944 4.674 6.572 6.572 0 0 1-1.944 4.675Z",
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills",
    "data-testid": "svg-path"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.87066997c3f2debc7e5766d81969eff5.svg";
export { ForwardRef as ReactComponent };